import { gql } from '@apollo/client';

export const GET_REVIEW_ORDER_DETAILS = gql`
  query GetReviewOrderDetails($input: ReviewOrderDetailsInput!) {
    reviewOrderDetailsByIds(input: $input) {
      orders {
        id
        creatorOrderRequest
        orderRequestStatus
        raw
      }
      variantMembersData
      totalProducts
      totalValue
      variantIds
    }
  }
`;
